import { render } from "./FormAlt.vue?vue&type=template&id=b6948782"
import script from "./FormAlt.vue?vue&type=script&lang=js"
export * from "./FormAlt.vue?vue&type=script&lang=js"
script.render = render

export default script